module.exports = __webpack_public_path__ + "static/media/sport-ski.989c026f.vtt";